import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Nav_Interface } from 'src/app/Interface/Nav_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NavService {

constructor(private http:HttpClient) { }


Get(Token:String):Observable<any>{
  return this.http.get(environment.BaseUrl+ "Daro/Nav?token="+Token).pipe(
    map(data=>{
      return data as any
    })
  )
}

GetNotice(Token:String):Observable<Array<any>>{
  return this.http.get(environment.BaseUrl+ "Daro/Nav/GetNotice?token="+Token).pipe(
    map(data=>{
      return data as Array<any>
    })
  )
}

GetUser(Token:String,id:number,customer:boolean):Observable<Array<Nav_Interface>>{
  return this.http.get(environment.BaseUrl+ "Daro/Nav/GetUser?token="+Token+"&id="+id+"&customer="+customer).pipe(
    map(data=>{
      return data as Array<Nav_Interface>
    })
  )
}

CheckValidPage(Token:String,id:number):Observable<any>{
  return this.http.get(environment.BaseUrl+ "Daro/Nav/CheckValidPage?token="+Token+"&id="+id).pipe(
    map(data=>{
      return data as any
    })
  )
}

}
